import React, { Component } from "react";
import { compose, graphql } from "react-apollo";
import { Button, Card, Radio, Form, Header, Item } from "semantic-ui-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as messageActions from "../../actions/message-actions";
import { UpdatePassengerTicket } from "../../mutations/UpdatePassengerTicket";
import Field from "../Field";

export class AddTicketDisruption extends Component {
  state = {
    status: undefined
};

  handleSubmit = () => {
    const { status } = this.state
    const {
      flight: {id: flightId},
      passengerTicketId: id
    } = this.props
    const input = {
      ticket: {id},
      flightsPassengerTickets: [ {flightId, status} ]
    }
    this.props.UpdatePassengerTicket({
      variables: {
        input
      }
    })
    .then(({ data }) => {
      this.props.onFlightTicketCreated()
      this.props.actions.showMessage({
        header: 'Ticket disruption added',
        text: `Ticket will be automatically rescanned soon, check again later`,
        props: { success: true },
        duration: 4000
      });
    })
    .catch((error) => {
      console.dir(error)
      this.props.onFlightTicketCreated()
      this.props.actions.showMessage({
        header: `Claim for flight #${flightId} already created!`,
        text: `Someone could add ticket disruption meanwhile...`,
        props: { success: false },
        duration: 4000
      });
    })
  }

  handleRadioChange = (e, { value }) => this.setState({ status: value })

  actionButtons = () => (
    <Form.Group>
      <Button
        primary
        size="mini"
        floated="right"
        name="Flight"
        className="c-TicketDetails__add-btn"
        content={"Save"}
        disabled={this.state.status === undefined}
        onClick={this.handleSubmit}
        type="submit"
      />
      <Button
        color="red"
        size="mini"
        floated="right"
        name="Cancel"
        className="c-TicketDetails__add-btn"
        content={"Cancel"}
        onClick={() => this.props.cancelEdit()}
      />
    </Form.Group>
  )

  render() {
    const { status } = this.state
    const RADIO_OPTIONS = [
      {label: "Overbooked", value: "overbooked"}
    ]
    return (
      <Item.Group>
        <Item>
          <Item.Content>
            <Form loading={this.props.loading}>
              <Card fluid>
                <Card.Content>
                  <Header as="h4">Flight {this.props.flight.id}</Header>
                  <Form.Group>
                    {RADIO_OPTIONS.map(({label, value}, i) => (
                      <React.Fragment key={i}>
                      <Field>
                        <Radio
                          label={label}
                          name={label}
                          value={value}
                          checked={status === value}
                          onChange={this.handleRadioChange}
                        />
                      </Field>
                      </React.Fragment>
                    ))}
                  </Form.Group>
                {this.actionButtons()}
                </Card.Content>
              </Card>
            </Form>
          </Item.Content>
        </Item>
      </Item.Group>
    );
  }
}

const AddTicketDisruptionWithData = compose(
  connect(
    null,
    dispatch => ({
      actions: bindActionCreators(messageActions, dispatch)
    })
  ),
  graphql(UpdatePassengerTicket, { name: "UpdatePassengerTicket" })
)(AddTicketDisruption);

export default AddTicketDisruptionWithData;



// WEBPACK FOOTER //
// ./src/component/FlightView/AddTicketDisruption.js